import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomApplicantElement } from '../../../job-service/service-models/CustomApplicantElement';
import { Question } from '../../../job-service/service-models/Question';


@Directive()
export class QuestionComponent<T extends Question> implements OnInit {
    @Input() jobId: number;
    @Input() element: CustomApplicantElement;
    @Input() question: T;
    @Output() event: EventEmitter<Question> = new EventEmitter();

    ngOnInit() {

    }

    questionAnswered() {
      this.event.emit(this.question);
    }
}
